<template>
<!-- 入库备案数据页面/报表 -->
  <div id="CustomerOwnerDataReportTwo">
      <div id="right">
       <!-- 日期、组织架构 -->
       <HeadControl :optionsVal="true" :titleName="'入库备案数据'" ref="HeadControl" :showorg="false" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker"></HeadControl>
      <!-- 报表 -->
      <div class="reportView">
        <div class="histogram">
          <div id="BigThreemyCharts" ref="BigThreemyCharts"></div>
        </div>
        <div class="BottomBox">
        <div id="OnepieChart" ref="OnepieChart"></div>
        <div id="Twohistogram" ref="Twohistogram"></div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import * as Urls from '@/helper/Urls';
import HeadControl from '@/components/HeadControl'
export default {
components:{
  HeadControl
}, 
data() {
  return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      orgCode:'',
      dataRange:[],
      StorageRecordDataList:'', // 入库备案数据
      natureDataList:'',  // 性质数据
      PieChartData:[
        // {name:'收费',value:'80'},
        // {name:'不收费',value:'80'}
      ], // 饼图数据
      seriesArr : [],
      colors:[['#5bbbff', '#CACACA'], ['#FFB96E', '#CACACA']],
      recordPercent:'',
      recordEntries:'',
      statePercent:'',
      stateEntries:'',
  };
},  
created(){ 
},
mounted(){
    // let start = new Date();
    // let end = new Date();
    // start.setDate(1);
    // start.setHours(0);
    // start.setSeconds(0);
    // start.setMinutes(0);
    // start.setTime(start.getTime());
    // this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
    // 屏幕宽度
    let _this = this;  
    window.onresize = () => {
      return (() => {
      window.screenWidth = document.body.clientWidth + 17; //实时宽度
      _this.screenWidth = window.screenWidth;
     })();
    };
    
},  
methods:{
    init(){
        this.$refs.HeadControl.getDatas('');
        this.$refs.HeadControl.getSysOrg()
    },
    // 获取组织架构ID
    changeVal(val) {
       this.orgCode = val;
       this.getStorageRecordData()
       this.getNature()
       this.getCharge()
    },  
    // 获取对应时间
    changDate(val){
       this.dataRange=val
       this.getStorageRecordData()
       this.getNature()
       this.getCharge()      
    },
    // 时间
    changePicker(val){
       this.dataRange = val
       this.getStorageRecordData()
       this.getNature()
       this.getCharge()         
    },  
    getOrgCode(){
        this.$refs.HeadControl.getSysOrg()
    },   
    // 入库备案报表
    initChart1() {
        let Chart1 = this.$echarts.getInstanceByDom(this.$refs.BigThreemyCharts);
        if (Chart1 == null) {
          this.myChart1 = this.$echarts.init(this.$refs.BigThreemyCharts);
        }    
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                text: '入库备案',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',
                textStyle:{
                    fontWeight:500,
                }
                },
                grid: { 
                left:this.$route.query.identification ? '30' : '46px',
                right:this.$route.query.identification ? '15%' : '3%',
                bottom: '20px',
                top:'100px',
                containLabel: true
                },
                opacity:0.1,       
                tooltip: {
                  trigger: 'axis',
                  formatter:function(params){
                  let h = `<div>`;
                  params.reverse().forEach(item => {
                    if (item.seriesIndex == 1) {
                      h += `<div>${item.axisValue}：${item.data}个</div>`;
                    } else {
                      h += `<div>占比：${item.data}%</div></div>`
                    }
                  });
                    return h
                  }
                },
                legend: {
                  data: this.StorageRecordDataList.legend,
                  itemWidth: 40,// 单个icon的width（单位px）
                  itemHeight: 8,// 单个icon的height（单位px）
                  itemGap:20,// 每个icon之间的距离（单位px）
                  left:this.$route.query.identification ? '110' : '180',
                  top:'24',                  
                },
                xAxis: [
                  {
                    type: 'category',
                    offset:5,
                    data: this.StorageRecordDataList.xAxis.data,
                    axisPointer: {
                      type: 'shadow'
                    },
                    // 分隔线
                    splitLine: {
                      show: Math.max(...this.StorageRecordDataList.series[0].data,...this.StorageRecordDataList.series[1].data) == 0 ? false : true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    axisTick:{
                      show:false,
                    },  
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:'#DDDDDD'
                      }
                    },
                    axisLabel:{
                      color: '#666666',
                    },                     
                    axisPointer: {
                      type: 'none'
                    }                                 
                  }
                ],
                yAxis: [
                  {
                    // 数据显示
                    offset:5,
                    type: 'value',
                    name: '百分比',
                    show:Math.max(...this.StorageRecordDataList.series[0].data) == 0 ? false : true,
                    min: 0,
                    max:this.recordPercent,
                    splitNumber:5,
                    interval:this.recordPercent / 5,
                    axisLabel: {
                      formatter: '{value}%',
                      textStyle:{
                          color:'#666666'
                      }
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      align:'left',
                      padding:this.$route.query.identification ?[0,35,0,0] : [0,40,0,0],
                      color:'#666666'
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }              
                  },
                  {
                    type: 'value',
                    name: '数量（个）',
                    show:Math.max(...this.StorageRecordDataList.series[1].data) == 0 ? false : true,
                    min: 0,
                    max: this.recordEntries,
                    // interval: this.recordEntries===0 ? 1:this.recordEntries / (this.recordPercent / 10),
                    splitNumber:5,
                    interval:this.recordEntries / 5,
                    axisLabel: {
                      formatter:params=>{
                        return parseInt(params)
                      },
                      textStyle:{
                          color:'#666666'
                      }                      
                    },
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                       padding:this.$route.query.identification ? [0,0,0,20] :  [0,0,0,38],
                       color:'#666666'
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }                    
                  }
                ],
                series: [
                  {
                    name: this.StorageRecordDataList.series[0].name,
                    type: 'bar',
                    barWidth :this.$route.query.identification ? 50  :  80,
                    yAxisIndex:0,
                    data: this.StorageRecordDataList.series[0].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(87,185,255,0.35)',
                      // opacity:Math.max(...this.StorageRecordDataList.series[0].data) == 0 ? 0 : 0.7,
                      borderColor:Math.max(...this.StorageRecordDataList.series[0].data) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                      }  
                    }
                  },
                  {
                    name: this.StorageRecordDataList.series[1].name,
                    type: 'line',
                    symbol:'rect',
                    symbolSize: 9,
                    hoverAnimation: false,
                    yAxisIndex:1,
                    data: this.StorageRecordDataList.series[1].data,
                    itemStyle:{
                      normal:{
                      color:'#72d8c0',
                      opacity:Math.max(...this.StorageRecordDataList.series[1].data) == 0 ? 0 : 1,
                      },
                      emphasis: {          //突出效果配置(鼠标置于拐点上时)
                      borderWidth: 3,
                      borderColor: '#61d9ac',
                      color: '#61d9ac',
                      },   
                    },
                    lineStyle:{
                      normal:{
                        opacity:Math.max(...this.StorageRecordDataList.series[1].data) == 0 ? 0 : 1,
                      }
                    }
                  },
                  
                ]
              };
      this.myChart1.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart1.resize(resize)
        } else {
          this.myChart1.resize()
        }
      })    
    },
    // 获取入库备案数据
    getStorageRecordData(){
      let _this = this
      let url =  Urls.getEchartsRegisterReportItemData
      let params =  {
        orgCode:this.orgCode,
        startTime:this.dataRange.length?this.dataRange[0]:'',
        endTime:this.dataRange.length?this.dataRange[1]:'',
        itemCode:'ENGINEERING_TYPE'
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }  

            _this.StorageRecordDataList = server_data.data
        })      
    },
    // 按状态报表
    initChart2() {
        let Chart2 = this.$echarts.getInstanceByDom(this.$refs.Twohistogram);
        if (Chart2 == null) {
          this.myChart2 = this.$echarts.init(this.$refs.Twohistogram);
        }         
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                text: '按状态',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',
                textStyle:{
                    fontWeight:500,
                }
                },
                grid: {
                left: this.$route.query.identification ? '36' : '46',
                right:this.$route.query.identification ? '15%' :  '3%',
                bottom: '5%',
                top:'28%',
                containLabel: true
                },
                opacity:0.1,       
                tooltip: {
                  trigger: 'axis',
                  formatter:function(params){
                  let h = `<div>`;
                  params.reverse().forEach(item => {
                    if (item.seriesIndex == 1) {
                      h += `<div>${item.axisValue}：${item.data}个</div>`;
                    } else {
                      h += `<div>占比：${item.data}%</div></div>`
                    }
                  });
                    return h
                  }
                },
                legend: {
                  data: this.natureDataList.legend,
                  itemWidth: 40,// 单个icon的width（单位px）
                  itemHeight: 8,// 单个icon的height（单位px）
                  itemGap:20,// 每个icon之间的距离（单位px）
                  left:this.$route.query.identification ? '110' : '180',
                  top:'24',
                },
                xAxis: [
                  {
                    type: 'category',
                    offset:5,
                    data: this.natureDataList.xAxis.data,
                    axisPointer: {
                      type: 'shadow'
                    },
                    // 分隔线
                    splitLine: {
                      show: Math.max(...this.natureDataList.series[0].data,...this.natureDataList.series[1].data) == 0 ? false : true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    axisTick:{
                      show:false,
                    },  
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:'#DDDDDD'
                      }
                    }, 
                    axisLabel:{
                      color: '#666666',
                    },                     
                    axisPointer: {
                      type: 'none'
                    }                                  
                  }
                ],
                yAxis: [
                  {
                    // 数据显示
                    offset:5,
                    type: 'value',
                    name: '百分比',
                    show:Math.max(...this.natureDataList.series[0].data) == 0 ? false : true,
                    min: 0,
                    max:  this.statePercent,
                    splitNumber:5,
                    interval: this.statePercent / 5,
                    axisLabel: {
                      formatter: '{value}%',
                      textStyle:{
                        color:'#666666'
                      }
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                      color:'#DDDDDD',
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      padding:this.$route.query.identification ?[0,35,0,0] :  [0,40,0,0],
                      color:'#666666'
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false, // 轴  
                  }              
                  },
                  {
                    type: 'value',
                    name: '数量（个）',
                    show:Math.max(...this.natureDataList.series[1].data) == 0 ? false : true,
                    min: 0,
                    max: this.stateEntries,
                    // interval: this.stateEntries===0 ? 1:this.stateEntries / (this.statePercent / 10),
                    splitNumber:5,
                    interval:this.stateEntries / 5 ,
                    axisLabel: {
                      formatter: params=>{
                        return parseInt(params)
                      },
                      textStyle:{
                          color:'#666666'
                      } 
                    },
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                       padding: [0,20,0,38],
                       color:'#666666'
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }                    
                  }
                ],
                series: [
                  {
                    name: this.natureDataList.series[0].name,
                    type: 'bar',
                    barWidth :this.$route.query.identification ? 50  :  80,
                    data: this.natureDataList.series[0].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(87,185,255,0.35)',
                      borderColor:Math.max(...this.natureDataList.series[0].data) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                      }  
                    }
                  },
                  {
                    name: this.natureDataList.series[1].name,
                    type: 'line',
                    symbol:'rect',
                    symbolSize: 9,
                    hoverAnimation: false,
                    yAxisIndex: "1",
                    data: this.natureDataList.series[1].data,
                    itemStyle:{
                      normal:{
                      color:'#72d8c0',
                      opacity:Math.max(...this.natureDataList.series[1].data) == 0 ? 0 : 1,
                      },
                      emphasis: {          //突出效果配置(鼠标置于拐点上时)
                      borderWidth: 3,
                      borderColor: '#61d9ac',
                      color: '#61d9ac',
                      },   
                    },
                    lineStyle:{
                      normal:{
                        opacity:Math.max(...this.natureDataList.series[1].data) == 0 ? 0 : 1,
                      }
                    }
                  },
                  
                ]
              };
      this.myChart2.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart2.resize(resize)
        } else {
          this.myChart2.resize()
        }
      }) 
    },
    // 获取状态
    getNature(){
      let _this = this
      let url = Urls.getEchartsStatusCountReportItemData
      let params = {
        orgCode:this.orgCode,
        startTime:this.dataRange.length?this.dataRange[0]:'',
        endTime:this.dataRange.length?this.dataRange[1]:'',
        itemCode:'NATURE_TYPE'        
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
            _this.statePercent = Math.ceil(Math.max(...server_data.data.series[0].data) / 10) * 10
            _this.stateEntries = Math.ceil(Math.max(...server_data.data.series[1].data) / 10) * 10
            _this.natureDataList = server_data.data
        })        
    }, 
    // 按收费报表
    initChart3(){
      let piePercent = ''
      let Chart3 = this.$echarts.getInstanceByDom(this.$refs.OnepieChart);
      if (Chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.OnepieChart);
      }       
      const option = {
         textStyle: {
           fontFamily: 'PingFang-M'
         },
         title: {
          text: '按收费',
          top:'24',  
          left:'30',
          textStyle:{
              fontWeight:500,
          }
        },
        color:["#57B9FF", "#FFB96E", "#E5E5E5"],
        series: [
          {
            name: this.PieChartData[0].name,
            type: "pie",
            startAngle: 180,
            center: ["25%", "50%"],
            radius:this.$route.query.identification ? ["40%", "44%"] :   (this.screenWidth <=1366 ? ["47%", "50%"] :["50%", "54%"]), // 决定圆环的位置及粗细
            avoidLabelOverlap: false, // 是否启用防止标签重叠策略
            hoverAnimation: false, // 关闭放大动画
            selectedOffset: 0, // 选中块的偏移量
            label: {
              normal: {
                show: false,
                position: "center",
                //   formatter: "{a}\n{c}个\n{d}%",
                formatter: function (params) {
                  piePercent = params.percent.toFixed()
                  const str = `{a|${params.name}}\n{b|${params.value}}{a|个}\n{c|${piePercent}%}`;
                  return str;
                },
                textStyle: {
                  rich: {
                    a: {
                      color: "#666",
                      fontSize: 14,
                      lineHeight: 25,
                    },
                    b: {
                      color: "#333",
                      fontSize: 26,
                      fontWeight: 500,
                      lineHeight: 40,
                    },
                    c: {
                      fontSize: 14,
                      lineHeight: 30,
                    },
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                // 进度条数据data
                value: this.PieChartData[0].value,
                name: this.PieChartData[0].name,
                selected: true, //默认选中第一块
                label: {
                  normal: {
                    show: true, //默认显示第一块
                    fontSize: "20",
                    color: "#57B9FF",
                  },
                },
              },
              {
                // 灰色块data
                value: this.PieChartData[0].value===0?10:this.PieChartData[1].value,
                name: this.PieChartData[0].name,
                itemStyle: {
                  // 设置相同的默认颜色和高亮颜色
                  normal: { color: "#e5e5e5" },
                  emphasis: { color: "#e5e5e5" },
                },
              },
            ],
          },
          {
            name: this.PieChartData[1].name,
            type: "pie",
            startAngle: this.startAngle,
            // clockWise: false,
            center:this.$route.query.identification ? ["70%", "50%"] :  ["70%", "50%"],
            radius:this.$route.query.identification ? ["40%", "44%"] :   (this.screenWidth <=1366 ? ["47%", "50%"] :["50%", "54%"]), // 决定圆环的位置及粗细
            avoidLabelOverlap: false, // 是否启用防止标签重叠策略
            hoverAnimation: false, // 关闭放大动画
            selectedOffset: 0, // 选中块的偏移量
            label: {
              normal: {
                show: false,
                position: "center",
                formatter: function (params) {
                  const str = `{a|${params.name}}\n{b|${params.value}}{a|个}\n{c|${piePercent == 0 ? 0 : (100-piePercent)}%}`;
                  return str;
                },
                textStyle: {
                  rich: {
                    a: {
                      color: "#666",
                      fontSize: 14,
                      lineHeight: 25,
                    },
                    b: {
                      color: "#333",
                      fontSize: 26,
                      fontWeight: 500,
                      lineHeight: 40,
                    },
                    c: {
                      fontSize: 14,
                      lineHeight: 30,
                    },
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                // 进度条数据data
                value: this.PieChartData[1].value,
                name: this.PieChartData[1].name,
                selected: true, //默认选中第一块
                label: {
                  normal: {
                    show: true, //默认显示第一块
                    fontSize: "20",
                    color: "#FFB96E",
                  },
                },
              },
              {
                // 灰色块data
                value: this.PieChartData[1].value === 0 ? 10:this.PieChartData[0].value,
                name: this.PieChartData[1].name,
                itemStyle: {
                  // 设置相同的默认颜色和高亮颜色
                  normal: { color: "#e5e5e5" },
                  emphasis: { color: "#e5e5e5" },
                },
              },
            ],
          },
        ],
      }; 
      this.myChart3.setOption(option)
       window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart3.resize(resize)
        } else {
          this.myChart3.resize()
        }
      })              
    },
    // 获取收费
    getCharge(){
      let _this = this
      let url = Urls.getEchartsChargeReportItemData
      let params = {
        orgCode:this.orgCode,
        startTime:this.dataRange.length?this.dataRange[0]:'',
        endTime:this.dataRange.length?this.dataRange[1]:'',
        itemCode:'CHARGE_TYPE'  
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
            _this.PieChartData = server_data.data
        }) 
    },
    // 时间
    changeDate(val){
      this.dataRange = val
      this.getStorageRecordData()
      this.getNature()
      this.getCharge()
    }
},
watch:{
  StorageRecordDataList(val){
    if(val){
      this.recordPercent = Math.ceil(Math.max(...val.series[0].data) / 10) * 10
      this.recordEntries = Math.ceil(Math.max(...val.series[1].data) / 10) * 10  
      this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      })   
      this.initChart1()     
    }
  },
  natureDataList(){
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    }) 
    this.initChart2()
  },
  PieChartData(){
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    }) 
    this.initChart3()
  }
},
computed:{
startAngle(){
  let total = this.PieChartData[0].value + this.PieChartData[1].value;
  if (total === 0) {
      return 180;
    } else {
      let res = (this.PieChartData[0].value / total) * 360;
      if (res > 180) {
       return 360 + (180 - res);
     } else {
       return 180 - res;
     }
   }
  }
},
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
#CustomerOwnerDataReportTwo{
  #right{
     box-sizing: border-box;
     .reportView{
     .histogram{
        width: 100%;
        height: 5rem;
        margin-top: 0.29rem;
        //  padding: 0.24rem 0 0.3rem 0.54rem;
        #BigThreemyCharts{
         width: 100%;
         height: 5rem; 
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
        }
     }
     .BottomBox{
      margin-top: 0.24rem;
      display: flex;
      #OnepieChart{
        height: 3.5rem;
        width: 50%;
        margin-right: 0.12rem;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
      }
      #Twohistogram{
        height: 3.5rem;
        width: 50%;
        margin-left: 0.12rem;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
      }
     }
     }

  }
}
@media screen and (max-width: 768px) {
  #CustomerOwnerDataReportTwo{
    #right{
      box-sizing: border-box;
      .reportView{
        .BottomBox{
          box-sizing: border-box;
          margin-top: 0.14rem;
          flex-direction: column;
          padding: 0 0.12rem;
          width: 100%;
          #OnepieChart,#Twohistogram{
            width: 100%;
            border: none;
            margin-left: 0;
            margin-right: 0;
            background-color: #fff !important;
          }
          #Twohistogram{
            margin-top: 0.14rem;
          }
        }
        .histogram{
          padding: 0 0.12rem;
          margin-top: 0.14rem;
          width: 100%;
           height: 4rem;
          box-sizing: border-box;
          #BigThreemyCharts{
            width: 100%;
            background-color: #fff !important;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius:0.1rem;
            border: none;
            height: 4rem;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 768px) {
   #CustomerOwnerDataReportTwo{
     .queryCondition {
       margin-bottom: 0;
     }
   }
}
</style>


// WEBPACK FOOTER //
// CustomerOwnerDataReportTwo.vue?623dc310